import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import { AiFillAndroid, AiFillApple } from 'react-icons/ai';
import Wave from '../Animations/Wave/wave';
import './style.scss';

const Intro = () => {
  return (
    <div className="intro">
      <Wave />
      <Container className="intro-content">
        <Row className="align-items-center">
          <Col lg={6} md={8}>
            <h1>Jobbrn!</h1>
            <p>
              Bist du bereit, deinen Alltag auf ein neues Level zu bringen?
              Möchtest du endlich Unterstützung bei Alltagsaufgaben oder gar
              dein Hobby zu Geld machen? Dann lade dir die App jetzt herunter
              und revolutioniere deinen Alltag!
            </p>
            <div className="button-container">
              <a
                href="https://apps.apple.com/de/app/jobbrn/id1525126986"
                target="blank">
                <Button variant="outline-dark">
                  <AiFillApple />
                  Apple Store
                </Button>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.jobbrn.jobbrn"
                target="blank">
                <Button variant="outline-dark">
                  <AiFillAndroid />
                  Google Play
                </Button>
              </a>
            </div>
          </Col>
          <Col lg={{ span: 3, offset: 2 }} md={4} className="text-center">
            <div className="intro-img">
              <img alt="" src={require('assets/mockup.png')} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Intro;
